import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-default',
	templateUrl: './default.component.html',
	styleUrls: ['./default.component.scss']
})
export class DefaultComponent {
	@Input() componentData: any;
	@Input() formHeight: string;
	editComponentName = Boolean(false);

	constructor() {}
}
